import {lazy} from 'react'
import {Route, Routes} from 'react-router-dom'

/*Rotas para Historico de Atividades*/
const DatatableMyTicket = lazy(() => import('../../pages/support/tickets/DatatableMyTicket'))
const DatatableAllTicket = lazy(() => import('../../pages/support/tickets/DatatableAllTicket'))
const ShowTicket = lazy(() => import('../../pages/support/tickets/ShowTicket'))

export function SupportRouter() {
    return (
        <Routes>
            {/* Paths relativos ao prefixo /suporte consumido em PrivateRoutes */}
            {/*Rotas para Historico de Atividades*/}
            <Route path='tickets/meus' element={<DatatableMyTicket />} />
            <Route path='tickets/clinica' element={<DatatableAllTicket />} />
            <Route path='tickets/:id' element={<ShowTicket />} />
        </Routes>
    )
}
